/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioCategoryCreateDto } from '../../models/portfolio-category-create-dto';
import { PortfolioCategoryDto } from '../../models/portfolio-category-dto';

export interface PortfolioCategoryAdminControllerCreateV1$Params {
      body: PortfolioCategoryCreateDto
}

export function portfolioCategoryAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: PortfolioCategoryAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioCategoryAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioCategoryDto>;
    })
  );
}

portfolioCategoryAdminControllerCreateV1.PATH = '/api/v1/portfolios/categories/admin';
